import React from "react";
import { FormattedMessage } from "react-intl";

import { MESSAGES } from "./i18n/useMessages";
import createBaseRenderer from "./createBaseRenderer";

export default createBaseRenderer({
  name: "anoNe",
  placeholderText: "NE",
  content: ({ val }) => {
    const message = val ? MESSAGES.ano : MESSAGES.ne;
    return <FormattedMessage {...message} />;
  }
});
